import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { gsap } from 'gsap';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    gsap.fromTo('.header', 
      { y: -100, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }
    );
  }, []);

  return (
    <header className="header fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm shadow-lg border-b border-accent">
      <div className="section-content">
        <div className="flex justify-between items-center py-4">
          {/* Company Logo */}
          <div className="flex items-center">
            <Link to="/" className="transition-transform hover:scale-105">
              <img 
                src="/mahofinefoodslogo.png" 
                alt="Maho Fine Foods Logo" 
                className="h-20 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'text-primary font-semibold' : ''}`}>Home</Link>
            {isHomePage && <a href="#about" className="nav-link">About</a>}
            {isHomePage && <a href="#services" className="nav-link">Services</a>}
            {isHomePage && <a href="#suppliers" className="nav-link">Suppliers</a>}
            <Link to="/products" className={`nav-link ${location.pathname === '/products' ? 'text-primary font-semibold' : ''}`}>Products</Link>
            {isHomePage ? <a href="#contact" className="nav-link">Contact</a> : <Link to="/#contact" className="nav-link">Contact</Link>}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a href="tel:+17215503241" className="btn-primary">
              Call Us
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <div className="w-6 h-6 flex flex-col justify-center space-y-1">
              <span className={`block h-0.5 w-6 bg-text transition-transform duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
              <span className={`block h-0.5 w-6 bg-text transition-opacity duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-6 bg-text transition-transform duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-accent">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className={`nav-link ${location.pathname === '/' ? 'text-primary font-semibold' : ''}`} onClick={() => setIsMenuOpen(false)}>Home</Link>
              {isHomePage && <a href="#about" className="nav-link" onClick={() => setIsMenuOpen(false)}>About</a>}
              {isHomePage && <a href="#services" className="nav-link" onClick={() => setIsMenuOpen(false)}>Services</a>}
              {isHomePage && <a href="#suppliers" className="nav-link" onClick={() => setIsMenuOpen(false)}>Suppliers</a>}
              <Link to="/products" className={`nav-link ${location.pathname === '/products' ? 'text-primary font-semibold' : ''}`} onClick={() => setIsMenuOpen(false)}>Products</Link>
              {isHomePage ? <a href="#contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>Contact</a> : <Link to="/#contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>Contact</Link>}
              <a href="tel:+17215503241" className="btn-primary w-full text-center" onClick={() => setIsMenuOpen(false)}>Call Us</a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
